import { render, staticRenderFns } from "./TransferCompanySectionView.vue?vue&type=template&id=10a278c4&scoped=true&"
import script from "./TransferCompanySectionView.vue?vue&type=script&lang=js&"
export * from "./TransferCompanySectionView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a278c4",
  null
  
)

export default component.exports